import React from 'react';
import { Box, Typography, Paper, Grid, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguageUrl } from '../../utils/languageUtils';
import PeopleIcon from '@mui/icons-material/People';
import EmailIcon from '@mui/icons-material/Email';
import ArticleIcon from '@mui/icons-material/Article';

const AdminDashboard: React.FC = () => {
  const { t } = useTranslation('admin');
  const { user } = useAuth();
  const navigate = useNavigate();
  const getLanguageUrl = useLanguageUrl();

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {t('dashboard.welcome')}
      </Typography>
      
      <Typography variant="body1" color="text.secondary" paragraph>
        {t('dashboard.description')}
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              {t('dashboard.userInfo')}
            </Typography>
            <Typography variant="body2">
              <strong>{t('dashboard.email')}:</strong> {user?.email}
            </Typography>
            <Typography variant="body2">
              <strong>{t('dashboard.name')}:</strong> {user?.fullName || t('dashboard.notSet')}
            </Typography>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              {t('dashboard.features.title')}
            </Typography>
            <Typography variant="body2" component="ul" sx={{ pl: 2 }}>
              <li>{t('dashboard.features.userManagement')}</li>
              <li>{t('dashboard.features.emailQueue')}</li>
              <li>{t('dashboard.features.settings')}</li>
              <li>{t('dashboard.features.reports')}</li>
            </Typography>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              {t('dashboard.quickActions')}
            </Typography>
            <Box display="flex" flexDirection="column" gap={2}>
              <Button
                variant="outlined"
                startIcon={<PeopleIcon />}
                onClick={() => navigate(getLanguageUrl('adminUserManagement'))}
              >
                {t('dashboard.actions.manageUsers')}
              </Button>
              <Button
                variant="outlined"
                startIcon={<EmailIcon />}
                onClick={() => navigate(getLanguageUrl('adminEmailQueue'))}
              >
                {t('dashboard.actions.viewEmailQueue')}
              </Button>
              <Button
                variant="outlined"
                startIcon={<ArticleIcon />}
                onClick={() => navigate(getLanguageUrl('adminPublications'))}
              >
                {t('dashboard.actions.viewPublications')}
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboard;
